// extracted by mini-css-extract-plugin
module.exports = {"pik-number":"_9330de7794--pik-number--_ppv_"};